import { graphClient } from '../graph-client'
import {
  GET_ANY_PROFILE,
  GET_PROFILE,
  GET_PROFILE_MINI,
  GET_USER_COINS,
  GET_USERS,
  REMOVE_USER_PHOTO,
  UPDATE_PROFILE,
} from './gql'
import type {
  Profile,
  ProfileMini,
  ProfileOther,
  Profiles,
  RemoveUserPhoto,
  UpdateProfile,
  UserCoins,
} from './types'

class ProfileService {
  async getMini() {
    const request = await graphClient.request<ProfileMini.Output>(GET_PROFILE_MINI)

    return request?.getProfileMini
  }

  async get() {
    const request = await graphClient.request<Profile.Output>(GET_PROFILE)

    return request?.getProfile
  }

  async getCoins() {
    const request = await graphClient.request<UserCoins.Output>(GET_USER_COINS)

    return request?.getUserCoins
  }

  async getOther(params: ProfileOther.Input) {
    const request = await graphClient.request<ProfileOther.Output>(
      GET_ANY_PROFILE,
      params,
    )

    return request?.getAnyProfile
  }

  async getList({ take = 20, skip = 0, ...params }: Profiles.Input) {
    const request = await graphClient.request<Profiles.Output>(GET_USERS, {
      ...params,
      take,
      skip: take * skip,
    })

    return request?.getUsers
  }

  async update(params: UpdateProfile.Input) {
    const request = await graphClient.request<UpdateProfile.Output>(
      UPDATE_PROFILE,
      params,
    )

    return request?.updateProfile
  }

  async removeUserPhoto(params: RemoveUserPhoto.Input) {
    const request = await graphClient.request<RemoveUserPhoto.Output>(
      REMOVE_USER_PHOTO,
      params,
    )

    return request?.removeUserPhoto
  }
}

export const profileService = new ProfileService()
